import { fetchInstance } from '../utils/fetchInstance.ts';
import type { User } from './user.ts';

export const loginByDiscord = async ({ username }: { username: string }) => {
  return await fetchInstance.post<void>('auth/login/discord', {
    username,
  });
};

export const loginByPassword = async ({
  username,
  password,
}: {
  username: string;
  password: string;
}): Promise<{ user: User }> => {
  return fetchInstance.post<{ user: User }>('auth/login/password', {
    username,
    password,
  });
};

export const approveDiscordAuth = async (token: string): Promise<{ user: User }> => {
  return fetchInstance.post<{ user: User }>('auth/login/discord/approve', { token });
};
